import {
	botByID,
	botCheck,
	botCreate,
	botDestroy,
	botSecret,
	botUpdate,
	botsList,
} from '@/services/bots.service'

export default {
	namespaced: true,
	state: {
		botsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		bot: {},
		botsStatus: 'pending',
		botSaveStatus: 'init',
		botDeleteStatus: 'init',
		botCheckStatus: 'init',
	},
	getters: {
		getBotsList(state) {
			return state.botsList
		},
		getBot(state) {
			return state.bot
		},
		getBotsStatus(state) {
			return state.botsStatus
		},
		getBotSaveStatus(state) {
			return state.botSaveStatus
		},
		getBotDeleteStatus(state) {
			return state.botDeleteStatus
		},
		getBotCheckStatus(state) {
			return state.botCheckStatus
		},
	},
	mutations: {
		BOTS_LIST(state, value) {
			state.botsList = value
		},
		SET_BOT(state, value) {
			state.bot = value
		},
		BOTS_STATUS(state, value) {
			state.botsStatus = value
		},
		BOT_SAVE_STATUS(state, value) {
			state.botSaveStatus = value
		},
		BOT_DELETE_STATUS(state, value) {
			state.botDeleteStatus = value
		},
		BOT_CHECK_STATUS(state, value) {
			state.botCheckStatus = value
		},
	},
	actions: {
		// Also used by the channel forms (per_page 'all', filtered by the caller).
		async fetchBotsList({ commit }, params) {
			commit('BOTS_STATUS', 'pending')
			try {
				const { data } = await botsList(params)
				commit('BOTS_STATUS', 'init')
				commit('BOTS_LIST', data)
				return data
			} catch (error) {
				commit('BOTS_STATUS', 'init')
				throw error
			}
		},
		async fetchBotByID({ commit }, id) {
			commit('BOTS_STATUS', 'pending')
			try {
				const { data } = await botByID(id)
				commit('BOTS_STATUS', 'init')
				commit('SET_BOT', data.data)
				return data
			} catch (error) {
				commit('BOTS_STATUS', 'init')
				throw error
			}
		},
		async saveNewBot({ commit }, params) {
			commit('BOT_SAVE_STATUS', 'pending')
			try {
				const { data } = await botCreate(params)
				commit('BOT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateBot({ commit }, params) {
			commit('BOT_SAVE_STATUS', 'pending')
			try {
				const { data } = await botUpdate(params)
				commit('BOT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteBotByID({ commit }, params) {
			commit('BOT_DELETE_STATUS', 'pending')
			try {
				const { data } = await botDestroy(params)
				commit('BOT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOT_DELETE_STATUS', 'init')
				throw error
			}
		},
		async checkBot({ commit }, id) {
			commit('BOT_CHECK_STATUS', 'pending')
			try {
				const { data } = await botCheck(id)
				commit('BOT_CHECK_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOT_CHECK_STATUS', 'init')
				throw error
			}
		},

		// Returned to the caller instead of committed: it should live only as
		// long as the dialog that asked for it, not in shared state.
		async revealBotSecret(_, id) {
			const { data } = await botSecret(id)

			return data?.data?.data || data?.data || data
		},
	},
}
